import { getEnv, envEnum } from 'src/utils/crossEnv'

import { ENV_BACKEND_URL, TEnv } from './backend.config'

const env = getEnv(envEnum.NEXT_PUBLIC_ENVIRONMENT)
const CURRENT_ENV = env as TEnv

export const getConnectionUrl = (path: string) => {
  return `${ENV_BACKEND_URL[CURRENT_ENV]}${path}`
}
